import React from 'react';
import { useTranslation } from 'react-i18next';
import ShareIcon from '@mui/icons-material/Share';
import InfoIcon from '@mui/icons-material/Info';
import HomeIcon from '@mui/icons-material/Home';
import GroupIcon from '@mui/icons-material/Group';
import { useTheme } from '@mui/material';
import { Pages } from '../state/queryParams/pageQueries.slice';
import { Layout } from '../components/layout/layout.smart';

export function GuardianLayout() {
  const { t } = useTranslation();
  const theme = useTheme();

  const drawerNavigationItems = [
    {
      text: t('HOME'),
      icon: <HomeIcon sx={{ fill: theme.palette.text.primary }} />,
      link: '.',
    },
    {
      link: Pages.players,
      text: t('PLAYERS_PAGE'),
      icon: <GroupIcon sx={{ fill: theme.palette.text.primary }} />,
      withDivider: true,
    },
    {
      link: `${Pages.conneqt}`,
      text: t('CONNEQT'),
      icon: <ShareIcon sx={{ fill: theme.palette.text.primary }} />,
      withDivider: true,
    },
    {
      link: 'about-us',
      text: t('ABOUT_CONNEQT'),
      icon: <InfoIcon sx={{ fill: theme.palette.text.primary }} />,
    },
  ];

  return <Layout drawerNavigationItems={drawerNavigationItems} />;
}
